import api from './api';
import { Artikel, ArtikelImportErgebnis, CreateArtikelRequest, UpdateArtikelRequest } from '../types';

export const artikelService = {
  getAll: async (): Promise<Artikel[]> => {
    const response = await api.get('/artikel');
    return response.data;
  },

  // Wie viele Positionen laufender Verträge den Artikel verwenden (Vorschau fürs Ersetzen).
  verwendung: async (id: number): Promise<number> => {
    const response = await api.get(`/artikel/${id}/verwendung`);
    return response.data.laufendeVertragspositionen;
  },

  // ADMIN: Artikel in allen laufenden Verträgen durch einen anderen ersetzen; liefert die Anzahl.
  ersetzen: async (id: number, durch: number): Promise<number> => {
    const response = await api.post(`/artikel/${id}/ersetzen`, null, { params: { durch } });
    return response.data.ersetzt;
  },

  create: async (data: CreateArtikelRequest): Promise<Artikel> => {
    const response = await api.post('/artikel', data);
    return response.data;
  },

  update: async (id: number, data: UpdateArtikelRequest): Promise<Artikel> => {
    const response = await api.put(`/artikel/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/artikel/${id}`);
  },

  // ADMIN: exportierte Preisliste (.xls/.xlsx) hochladen – Merge über die Artikelnummer.
  importExcel: async (file: File): Promise<ArtikelImportErgebnis> => {
    const formData = new FormData();
    formData.append('file', file);
    // Content-Type bewusst nicht setzen → der Browser ergänzt die Multipart-Boundary selbst
    // (der globale Default 'application/json' aus api.ts würde das sonst kaputt machen).
    const response = await api.post('/artikel/import', formData, {
      headers: { 'Content-Type': undefined },
    });
    return response.data;
  },
};

export default artikelService;
